export const INSPECTORS = [
  'Ing. Luca Milanesi',
  "Ing. Francesca D'Amico",
  'Per. Ind. Paolo Corsi',
  'Ing. Giulia Rinaldi',
];

export const PERSON_ROLES = [
  'Responsabile Sicurezza',
  'Capo Manutentore',
  'Tecnico Refrigerazione',
  'Operatore Sala Macchine',
  'Rappresentante Cliente',
];

export const FIRST_NAMES = [
  'Marco',
  'Giulia',
  'Luca',
  'Sara',
  'Francesco',
  'Alessia',
  'Paolo',
  'Elena',
  'Chiara',
  'Giorgio',
];

export const LAST_NAMES = [
  'Rossi',
  'Bianchi',
  'Ferrari',
  'Conti',
  'Galli',
  'Romano',
  'Greco',
  'Ferri',
  'Gallo',
  'Costa',
];
